module.exports = __webpack_public_path__ + "static/media/pdf-external.45e645a2.svg";